// extracted by mini-css-extract-plugin
export default {"container":"favorite-icon-module__container___Onhhf","favoriteHeart":"favorite-icon-module__favoriteHeart___ChvQA"};